<div class="widget-framework">
    <jafar-page-widget class="widget"
        [contents]="contentTemplate"
        [actions]="actionTemplate"
    >
        <div title>Custom Groups</div>
        <div subtitle> Manage Azure Custom Groups </div>
    </jafar-page-widget>
</div>

<ng-template #contentTemplate >
    This is where you can manage your Azure Custom Groups<br>
</ng-template>

<ng-template #actionTemplate>
    <button mat-icon-button matTooltip="View Groups" (click)="viewClicked()">
        <mat-icon>visibility</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Create Group" (click)="createClicked()" disabled="true">
        <mat-icon>add_circle</mat-icon>
    </button>
</ng-template>
